<template>
  <div v-if="showView" class="page-alert flex flex-center zindex-tip">
    <div class="page-body bg-white">
      <div class="page-header flex-row-align-center flex-row-justify-space-between">
        <p class="font-size-24 font-bold">年份</p>
        <img class="cursor" src="../../../../../assets/icon-lib-close-blue.png" alt="" @click="showView = false">
      </div>
      <div class="page-options">
        <div class="page-options-region-date flex-row-align-center">
          <div class="flex-row-align-center">
            <p class="font-size-12 font-color-999 space">显示{{ total }}中的{{ range.start }}-{{ range.end }}条</p>
            <p class="font-size-12 font-color-264480 space cursor" :class="currentPage==1?'disabel':''" @click="prePage">上一页</p>
            <p class="font-size-12 font-color-264480 cursor" :class="currentPage==pages?'disabel':''" @click="nextPage">下一页</p>
          </div>
        </div>

        <div class="page-content bg-white">
          <div class="menu-content-item-list">
            <div v-for="(cate, index) in datas" :key="index" class="menu-content-item-list-item" @click="selectCate(cate)">
              <div class="flex-row-align-center flex-row-justify-space-between menu-content-item-list-item-hg cursor radius-clip-5" :class="currentDate.name == cate.name?'bg-262A33':''">
                <p class="font-size-14">{{ cate.name }}</p>
                <p class="font-size-14 font-color-999">{{ cate.counrNumber }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="page-footer flex-center bg-white">
          <p class="bg-282B80 font-color-white flex-center font-size-14 radius-clip-5 btn cursor" @click="confirm">确定</p>
          <p class="bg-F3F4F9 font-color-264480 flex-center font-size-14 radius-clip-5 btn cursor" @click="closeView">关闭</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '../../../../../api/collections.js'

export default {
  data() {
    return {
      showView: false,
      topicTopSelIndex: 0,
      personLetters: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
      personTopSelIndex: 0,
      currentCate: null,
      currentLogs: null,
      catedata: null,

      reqParams: {},

      currentPage: 1,
      pages: 0,
      total: 0,
      range: { start: 0, end: 0 },
      dataType: '',

      datas: [],
      currentDate: {
        name: '',
        data: ''
      }
    }
  },
  destroyed() {
    console.log('销毁')
  },
  methods: {
    show(data, type) {
      this.reqParams = { size: 10, current: this.currentPage }
      for (const key in data) {
        if (key === 'current' || key === 'size' || key === 'sortType') {
          continue
        } else {
          this.reqParams[key] = data[key]
        }
      }
      this.request()
      this.showView = true
    },
    request() {
      this.reqParams.current = this.currentPage
      const that = this
      this.reqParams.data.tenantId = this.$store.getters.tenantId 
      api.datePage(this.reqParams).then(r => {
        that.total = r.data.total
        that.datas = r.data.records
        that.range.end = (that.currentPage - 1) * 10 + that.datas.length
        that.range.start = (that.currentPage - 1) * 10 + 1
        that.pages = r.data.pages
      })
    },
    prePage() {
      if (this.currentPage > 1) {
        this.currentPage -= 1
        this.request()
      }
    },
    nextPage() {
      if (this.currentPage < this.pages) {
        this.currentPage += 1
        this.request()
      }
    },
    selectCate(v) {
      if (this.currentDate.name !== v.name) {
        this.currentDate.name = v.name
        this.currentDate.data = v
      }
    },
    confirm() {
      this.showView = false
      this.$emit('select', { params: { chronicleDates: this.currentDate.name }, display: this.currentDate.name, type: 'chronicleDates' })
    },
    closeView() {
      this.total = 0
      this.currentPage = 1
      this.range.start = 0
      this.range.end = 0
      this.showView = false
      this.currentDate.name = ''
      this.currentDate.data = ''
    }
  }
}
</script>
<style src="@/styles/pc.css" scoped>
</style>
<style scoped>
  .page-alert {
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
  }

  .page-body {
    width: 500px;
  }

  .page-header {
    padding: 0 20px;
    height: 60px;
  }

  .page-options {
    border-bottom: 1px solid #eee;
  }

  .page-options-region-topic {
    height: 40px;
    padding: 0 20px;
  }

  .page-options-selection>div {
    padding: 0 6px;
    width: 40px;
    height: 40px;
  }

   .page-options-selection .line {
     height: 3px;
     width: 40px;
     bottom: 0;
   }

  .page-options-region-date{
    height: 40px;
    justify-content: end;
    padding: 0 16px;
  }

  .space {
    margin-right: 8px;
  }

  .page-content {
    height: 380px;
    overflow: scroll;
  }

  .page-footer {
    height: 60px;
  }

  .page-footer .btn {
    width: 100px;
    height: 30px;
    font-weight: 400;
    margin-right: 10px;
  }

  .page-footer .btn:last-child {
    margin: 0;
  }

  .page-options-region-person-pages {
    height: 24px;
    justify-content: end;
    padding: 0 20px;
  }

  .page-options-region-person-items {
    height: 24px;
    padding: 0 20px;
    margin-bottom: 10px;
  }

  .page-options-region-person-items .item {
    padding: 0 4px;
  }

  .page-options-region-person-items .item .p-line {
    left: 0;
    right: 0;
    bottom: -10px;
    height: 3px;
  }

  .menu-content-item-list-item-hg {
    height: 30px;
    padding: 0 10px;
  }

  .menu-content-item-list {
    padding: 10px;
  }
  .cate-sel-close {
    width: 30px;
    height: 30px;
  }

  .disabel {
    color: #999;
    cursor: not-allowed;
  }
</style>
